module.exports = __webpack_public_path__ + "img/logo@2x.4aae9bb3.png";